






































































































































import _ from "lodash";
import { ControleVehiculeApi } from "../api/ControleVehiculeApi";
import { VehiculeFlotte } from "../models/ControleVehicule";
import ExportButton from "../core/UI/ExportButton.vue";
import FlotteEditModal from "./FlotteEditModal.vue";
import EntretienList from "./EntretienList.vue";

export default {
    name: "FlotteList",
    components: { ExportButton, FlotteEditModal, EntretienList },
    data() {
        return {
            vehicules: [],
            search: "",
            showInactifs: false,
            loading: false,
            api: new ControleVehiculeApi(),
            selectedVehicule: null,
            showEditModal: false,
            showEntretienModal: false,
        };
    },
    computed: {
        displayedVehicules(): Array<VehiculeFlotte> {
            let self = this;
            if (!this.search) {
                return this.vehicules;
            }
            let s = this.search.toLowerCase();
            return _.filter(this.vehicules, function (v) {
                return (
                    (v.numero || "").toLowerCase().includes(s) ||
                    (v.immatriculation || "").toLowerCase().includes(s) ||
                    (v.marque || "").toLowerCase().includes(s) ||
                    (v.modele || "").toLowerCase().includes(s) ||
                    (v.chauffeur_nom || "").toLowerCase().includes(s)
                );
            });
        },
    },
    created() {
        this.load();
    },
    methods: {
        getExportParams() {
            return this.showInactifs ? { all: 1 } : {};
        },
        load() {
            this.loading = true;
            let params = this.showInactifs ? { all: 1 } : {};
            this.api.getFlotte(params).then((res) => {
                this.vehicules = res;
                this.loading = false;
            });
        },
        create() {
            this.selectedVehicule = null;
            this.showEditModal = true;
        },
        edit(vehicule) {
            this.selectedVehicule = vehicule;
            this.showEditModal = true;
        },
        openEntretien(vehicule) {
            this.selectedVehicule = vehicule;
            this.showEntretienModal = true;
        },
        onSaved() {
            this.showEditModal = false;
            this.load();
        },
    },
    watch: {
        showInactifs() {
            this.load();
        },
    },
};
